import React, { useEffect, useState } from 'react'
// import BranchImage from '../../../../Assets/images/BranchImage.png'
import { BRANCHES } from '../../../../Utilities/APIs';
import Image from '../../../Partials/Elements/Image/Image';

import './OrganizationBranches.css'

function OrganizationBranches({ organizationId }) {
    const [branches, setBranches] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);


    useEffect(() => {

        async function getAndSetBranches() {
            const statRes = await fetch(BRANCHES);
            const statData = await statRes.json();
            const singleOrganizationBranches = statData.filter(branch => branch.organization === organizationId);
            setBranches(singleOrganizationBranches);
            setSelectedBranch(singleOrganizationBranches[0]);
        }
        getAndSetBranches();

    }, [organizationId]);

    const selectBrachHandler = (id) => {
        setSelectedBranch(branches.find(brachid => brachid._id === id))
    }

    return (
        <>

            {branches && branches.length > 0 &&
                <div className='organization_branches'>
                    <h2>ব্র্যাঞ্চগুলির তথ্য</h2>
                    <div className="nav">
                        {
                            branches?.map((branch, index) => (
                                <button type='button' className={`nav_tab ${selectedBranch?._id === branch._id ? 'active' : ''}`} onClick={() => selectBrachHandler(branch._id)} key={branch._id}>ব্র্যাঞ্চ {index + 1}</button>
                            ))
                        }
                    </div>
                    <div className="nav_content">
                        <div className="image_wrapper">
                            {selectedBranch && <Image imgSrc={selectedBranch.image} imgAlt="hlhflsdh" />}
                        </div>
                        <div className="location_wrapper">
                            <div className="embaded_map">
                                <h5>ম্যাপ লোকেশন</h5>
                                {selectedBranch &&
                                    <iframe
                                        src={selectedBranch.mapLocation}
                                        title="map"
                                        style={{ boreder: '0' }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    >
                                    </iframe>}
                            </div>
                            <div className="phone_address">
                                <div>
                                    <h5>ফোন</h5>
                                    {selectedBranch && <p>{selectedBranch.branchPhoneNumber}</p>}

                                    {/* <p>0255037242</p> */}
                                </div>
                                <div>
                                    <h5>ঠিকানা</h5>
                                    {selectedBranch && <p>{selectedBranch.branchAddress}</p>}
                                    {/* <p>প্লট ৮১, ব্লক ই, বসুন্ধরা আর/এ, ঢাকা-১২২৯</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default OrganizationBranches

